import React from 'react';
import PropTypes from 'prop-types';
import initializeStore from './store';
import { ACTION_TYPES } from 'flaivy-react/reducers/error.reducer';

const isServer = typeof window === 'undefined';
const NEXT_REDUX_STORE = 'NEXT_REDUX_STORE';

function getOrCreateStore(initialState) {
  // Always make a new store if server, otherwise state is shared between requests
  if (isServer) {
    return initializeStore(initialState);
  }

  // Create store if unavailable on the client and set it on the window object
  if (!window[NEXT_REDUX_STORE]) {
    window[NEXT_REDUX_STORE] = initializeStore(initialState);
  }
  return window[NEXT_REDUX_STORE];
}

const withReduxStore = App => {
  return class AppWithRedux extends React.Component {
    static get propTypes() {
      return {
        initialReduxState: PropTypes.object.isRequired,
      };
    }

    static async getInitialProps(appContext) {
      // Get or Create the store with `undefined` as initialState
      // This allows you to set a custom default initialState
      const reduxStore = getOrCreateStore({});
      // Provide the store to getInitialProps of pages
      // eslint-disable-next-line
      appContext.ctx.reduxStore = reduxStore;

      if (typeof window !== 'undefined') {
        window.addEventListener('error', err => {
          reduxStore.dispatch({
            type: ACTION_TYPES.ERROR,
            payload: err,
          });
        });
      }

      let appProps = {};
      if (typeof App.getInitialProps === 'function') {
        appProps = await App.getInitialProps(appContext);
      }

      // Provide props to pages
      return {
        ...appProps,
        reduxStore,
        initialReduxState: {
          ...reduxStore.getState(),
        },
      };
    }

    constructor(props) {
      super(props);

      this.reduxStore = getOrCreateStore({
        ...props.initialReduxState,
      });
    }

    render() {
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      return <App {...this.props} reduxStore={this.reduxStore} />;
    }
  };
};

export default withReduxStore;
